import React from "react";

interface Props {
  size?: number;
}

// Icon matching Chrome's address-bar install-app button: a monitor/tablet
// outline with a down-arrow inside it.
const InstallIcon: React.FC<Props> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    style={{ verticalAlign: "-3px", margin: "0 3px" }}
  >
    <rect x="3" y="3" width="18" height="16" rx="2" />
    <path d="M12 8v6" />
    <path d="M9 11l3 3 3-3" />
  </svg>
);

export default InstallIcon;
